import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

//services
import { OrderService } from './shared/services';

//helpers
import { OrderHelper } from './shared/helpers';
import { PaymentStatusEnum, ProductIdentifierEnum, ProductTypeEnum } from './shared/enums';
import { OrderInterface } from './shared/interfaces';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'volg-cashier';
    @ViewChild('restart', { static: false }) restart: ElementRef;
    @ViewChild('modal', { static: false }) modal: ElementRef;
    @ViewChild('fallback', { static: false }) fallbackModal: ElementRef;

    public time: number = 0;
    public code: string = '';

    public seconds: number = 5;
    public fallback: boolean = false;
    private currentRoute: string = '';

    private $interval: any;
    private $fallback: Subscription;


    private debounceStorecard: Subject<string> = new Subject();
    private $debounceStorecard: Subscription;

    private debounceTouch: Subject<boolean> = new Subject();
    private $debounceTouch: Subscription;

    @HostListener('document:click', ['$event'])
    documentClick(event: MouseEvent) {
        this.debounceTouch.next(true);
    }

    @HostListener('window:keypress', ['$event'])
    codeScanned(event: KeyboardEvent) {
        if (event.key !== "Enter" && this.currentRoute !== '/config') {
            this.code += event.key;
            this.debounceStorecard.next(this.code);
            this.debounceTouch.next(true);
        }
    }

    constructor(
        private orderService: OrderService,
        private orderHelper: OrderHelper,
        private router: Router,
    ) {
        router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.currentRoute = val.url
            }
        });
    }

    ngOnInit(): void {
        this.$debounceStorecard = this.debounceStorecard.pipe(debounceTime(100)).subscribe(res => {
            this.code = '';
            this.productScanned(res);
        });
        this.$debounceTouch = this.debounceTouch.pipe(debounceTime(55000)).subscribe(res => {
            console.log(res)
            this.initFallback();
        });
        this.$fallback = OrderService.fallback.subscribe(res => {
            console.log(res)
            if (res) this.initFallback();
        });
    }


    public close() {
        this.modal.nativeElement.classList.add('close')
        setTimeout(() => {
            this.modal.nativeElement.classList.remove('close')
        }, 300);
    }

    private initFallback() {
        if (this.currentRoute == '/home' || (this.currentRoute == '/checkout' && OrderHelper.checkoutStatus.value === PaymentStatusEnum.pending) || this.currentRoute == '/config' || this.fallback) return
        this.fallback = true;
        OrderService.errorMessage.next(null);
        this.$interval = setInterval(() => {
            this.seconds--;
            if (!this.seconds) {
                console.log('initfallback')
                this.finishFallback();
            }
        }, 1000);
    }

    public stopFallback() {
        clearInterval(this.$interval);
        this.seconds = 5;
        this.fallback = false;
    }

    public finishFallback() {
        this.stopFallback();
        this.router.navigate(['/home'])
    }


    private productScanned(ean: string) {
        if (this.currentRoute == '/checkout' || this.currentRoute == '/control') return
        if (ean.startsWith('IAVQ') && (!OrderService.order.value || (OrderService.order.value && !OrderService.order.value.itemList.length))) {
            //import from pwa
            console.log(ean = ean.substring(5).replaceAll("'", '-'));
            this.orderService.getOrder(ean).subscribe({
                next: data => {
                    OrderService.order.next(JSON.parse(data.message));
                    this.orderHelper.recalculateOrder();
                    this.router.navigate(['/basket']);
                }
            })
        } else if (ean.length == 10) {
            //is employee batch length
            this.orderService.checkEmployeeNr(ean).subscribe({
                next: data => {
                    console.log(data)
                    OrderService.employee.next(data.is_employee);
                    this.orderHelper.recalculateOrder();
                    this.router.navigate(['/basket']);
                }
            })

        } else {
            if(!OrderService.order.value) OrderService.order.next(new OrderInterface());
            if (ean.startsWith('210')) {
                this.orderHelper.addToBasket(ean, ProductIdentifierEnum.barcode, ProductTypeEnum.quantityProduct);
            } else if (ean.startsWith('9988')) {
                ean = ean.replaceAll('$','#');
                ean = ean.replaceAll('[','#');
                ean = ean.replaceAll(']','#');
                ean = ean.replaceAll('*','#');
                this.orderHelper.addToBasket(ean, ProductIdentifierEnum.barcode, ProductTypeEnum.discountedProduct);
            } else {
                this.orderHelper.addToBasket(ean, ProductIdentifierEnum.barcode, ProductTypeEnum.regularProduct);      
            }
            this.router.navigate(['/basket']);
            this.orderHelper.recalculateOrder();
        }
    }
    ngOnDestroy(): void {
        if (this.$interval) {
            clearInterval(this.$interval);
        }
        this.$debounceStorecard.unsubscribe();
        this.$debounceTouch.unsubscribe();
        this.$fallback.unsubscribe();
    }
}